import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AvailabilityCalendarScreen from "src/app/screens/availabilityCalendar/availabilityCalendar.view";
import AvaialbilityManagementScreen from "src/app/screens/availabilityManagement/availabilityManagement.view";
import CloudieScreen from "src/app/screens/cloudie/cloudie.view";
import DashboardScreen from "src/app/screens/dashbaord/dashboard.view";
import EventDetailScreen from "src/app/screens/eventDetail/eventDetail.view";
import EventsScreen from "src/app/screens/events/events.view";
import FilesScreen from "src/app/screens/files/files.view";
import LoginScreen from "src/app/screens/login/login.screen.view";
import LogsScreen from "src/app/screens/logs/logs.view";
import MyCalendarScreen from "src/app/screens/myCalendar/myCalendar.view";
import PaymentsScreen from "src/app/screens/payments/payments.view";
import PodDashboardScreen from "src/app/screens/podDashboard/podDashboard.view";
import PodLogsScreen from "src/app/screens/podLogs/podLogs.view";
import RequestManagementScreen from "src/app/screens/requestManagement/requestManagement.view";
import ScheduleScreen from "src/app/screens/schedule/schedule.view";
import SettingsScreen from "src/app/screens/settings/settings.view";
import TaskRequestsScreen from "src/app/screens/taskRequests/taskRequests.view";
import TaskScreen from "src/app/screens/tasks/tasks.view";
import UsersManagementScreen from "src/app/screens/userManagement/userManagement.view";
import LimitedRoute from "src/app/utils/limitedRoute.util";
import ProtectedRoute from "src/app/utils/protectedRoute.util";

const theme = createTheme({
  typography: {
    fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
});

const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/" element={<LoginScreen />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<DashboardScreen />} />
              <Route
                element={<LimitedRoute roles={["Admin", "Parent", "Model"]} />}
              >
                <Route
                  path="/userManagement"
                  element={<UsersManagementScreen />}
                />
              </Route>
              <Route
                element={<LimitedRoute roles={["Admin", "Parent", "Model"]} />}
              >
                <Route
                  path="/availabilityManagement"
                  element={<AvaialbilityManagementScreen />}
                />
              </Route>
              <Route
                element={<LimitedRoute roles={["Admin", "Parent", "Model"]} />}
              >
                <Route
                  path="/availabilityCalendar"
                  element={<AvailabilityCalendarScreen />}
                />
              </Route>
              <Route
                path="/requestManagement"
                element={<RequestManagementScreen />}
              />
              <Route path="/calendar" element={<MyCalendarScreen />} />
              <Route path="/logs" element={<LogsScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
              <Route path="/podDashboard" element={<PodDashboardScreen />} />
              <Route path="/tasks" element={<TaskScreen />} />
              <Route path="/taskRequests" element={<TaskRequestsScreen />} />
              <Route path="/schedule" element={<ScheduleScreen />} />
              <Route path="/podLogs" element={<PodLogsScreen />} />
              <Route
                element={<LimitedRoute roles={["Admin", "Parent", "Model"]} />}
              >
                <Route path="/payments" element={<PaymentsScreen />} />
              </Route>
              <Route path="/cloudie" element={<CloudieScreen />} />
              <Route path="/files" element={<FilesScreen />} />
              <Route path="/events" element={<EventsScreen />} />
              <Route path="/events/:eventId" element={<EventDetailScreen />} />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default App;
